import { useState } from 'react';

type AvatarSize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg';

const SIZE_CLASSES: Record<AvatarSize, string> = {
  xxs: 'h-full w-full',
  xs: 'h-6 w-6',
  sm: 'h-9 w-9',
  md: 'h-11 w-11',
  lg: 'h-14 w-14',
};

const LETTER_CLASSES: Record<AvatarSize, string> = {
  xxs: 'text-[10px]',
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-lg',
  lg: 'text-lg',
};

interface AvatarProps {
  src: string | null | undefined;
  name: string;
  size?: AvatarSize;
  rounded?: 'full' | 'xl';
  className?: string;
}

export function Avatar({
  src,
  name,
  size = 'md',
  rounded = 'full',
  className = '',
}: AvatarProps) {
  const [broken, setBroken] = useState(false);
  const box = `${SIZE_CLASSES[size]} ${rounded === 'full' ? 'rounded-full' : 'rounded-xl'} ${className}`;
  if (src && !broken) {
    return (
      <img
        src={src}
        alt={name}
        className={`${box} shrink-0 object-cover border border-surface-border`}
        onError={() => setBroken(true)}
      />
    );
  }
  return (
    <div
      className={`${box} shrink-0 bg-accent/15 text-accent font-bold flex items-center justify-center border border-surface-border`}
    >
      <span className={LETTER_CLASSES[size]}>{(name || '?').charAt(0).toUpperCase()}</span>
    </div>
  );
}